export default __webpack_public_path__ + "static/media/duck2.ed318fc4.jpg";